import * as React from "react";
import { Box, Typography } from "@mui/material";

export default function ChatEmptyState() {
    return (
        <Box sx={{ textAlign: "center", mb: 3 }}>
            <Typography variant="h6" color="primary" sx={{ fontWeight: 600 }}>
                ieQip
            </Typography>
            <Typography variant="h4" sx={{ fontWeight: 600, mt: 0.5 }}>
                What would you like to know?
            </Typography>
        </Box>
    );
}
